/**
 * 团队管理实体
 */

import { useEffect, useState } from 'react';
import {
    Flex,
    Modal,
    Input,
    Row,
    Col,
    message,
    Select,
    Typography,
} from 'antd';
import $ from 'jquery';
import {
    AddRequestHeaders
} from '../../incs/FunHelper';

import CNF from '../../incs/Config';

const MODULENAME = '团队';

const { TextArea } = Input;
const { Text } = Typography;

const Entity = (props) => {
    const [messageApi, contextHolder] = message.useMessage();

    const [usersLists, setUsersLists] = useState([]);
    const [rolesLists, setRolesLists] = useState([]);
    const [loading, setLoading] = useState(false);
    const [groupname, setGroupname] = useState('');
    const [displayname, setDisplayname] = useState('');
    const [roleULID, setRoleULID] = useState('');
    const [adminUserULID, setAdminUserULID] = useState('');
    const [description, setDescription] = useState('');

    const cancel = () => {
        props.setOpen(false);
        setLoading(false);
        setGroupname('');
        setDisplayname('');
        setRoleULID('');
        setAdminUserULID('');
        setDescription('');
    };

    useEffect(() => {
        // 修改初始化
        if (props.record) {
            setGroupname(props.record.groupname);
            setDisplayname(props.record.displayname);
            setAdminUserULID(props.record.admin_user_ulid);
            setRoleULID(props.record.role_ulid);
            setDescription(props.record.description);
        }
    }, [props.record]);

    useEffect(() => {
        if (props.open && usersLists.length < 1) {
            /**
             * 获取用户下拉列表
             */
            $.ajax({
                url: `${CNF.api}users?rss=list`,
                headers: AddRequestHeaders(),
                type: 'GET',
                dataType: 'JSON',
            }).done(function (data) {
                if (data.res === 0 && data.dat.length > 0) {
                    setUsersLists(data.dat)
                }
            });
        }
    }, [props.open, usersLists]);

    useEffect(() => {
        if (props.open && rolesLists.length < 1) {
            /**
             * 获取角色下拉列表
             */
            $.ajax({
                url: `${CNF.api}roles?rss=list`,
                headers: AddRequestHeaders(),
                type: 'GET',
                dataType: 'JSON',
            }).done(function (data) {
                if (data.res === 0 && data.dat.length > 0) {
                    setRolesLists(data.dat)
                }
            });
        }
    }, [props.open, rolesLists]);

    const ok = () => {
        var rex = CNF.regex.groupname.exec(groupname)
        if (rex == null || rex[0] !== groupname) {
            messageApi.error('组名格式错误！');
            return;
        }
        if (!adminUserULID) {
            messageApi.error('管理员不能为空！');
            return;
        }
        if (!roleULID) {
            messageApi.error('角色不能为空！');
            return;
        }
        setLoading(true);
        $.ajax({
            url: CNF.api + 'groups' + (props.record ? '/' + props.record.key : ''),
            headers: AddRequestHeaders(),
            type: props.record ? 'PUT' : 'POST',
            dataType: 'JSON',
            data: JSON.stringify({
                groupname: groupname,
                role_ulid: roleULID,
                admin_user_ulid: adminUserULID,
                displayname: displayname,
                description: description,
            })
        }).done(function (data) {
            if (data.res === 0) {
                messageApi.success(data.msg, CNF.messageDuration);
                setTimeout(function () {
                    cancel();
                    props.refresh();
                }, CNF.messageDuration * 1000);
            } else {
                setLoading(false);
                messageApi.error(data.msg, CNF.messageDuration);
            }
        }).fail(function (data) {
            messageApi.error(data.responseJSON.detail, CNF.messageDuration);
        }).always(() => setTimeout(function () {
            setLoading(false);
        }, CNF.messageDuration * 1000))
    };


    return (
        <>
            {contextHolder}
            <Modal
                width={540}
                title={(props.record ? CNF.actionName.UPDATE : CNF.actionName.CREATE) + MODULENAME}
                open={props.open}
                onOk={ok}
                onCancel={cancel}
                keyboard={true}
                okText='确认'
                cancelText='取消'
                okButtonProps={{ loading }}
            >
                <Flex vertical gap='small'>
                    <Row>
                        <Col span={24}><Text>团队名</Text><Text type='danger'>*</Text></Col>
                        <Col span={24}>
                            <Input
                                placeholder='请输入'
                                onChange={(e) => setGroupname(e.target.value)}
                                value={groupname}
                                disabled={props.record ? true : loading}
                            />
                        </Col>
                    </Row>
                    <Row>
                        <Col span={24}><Text>显示名</Text><Text type='danger'>*</Text></Col>
                        <Col span={24}>
                            <Input
                                placeholder='请输入'
                                onChange={(e) => setDisplayname(e.target.value)}
                                value={displayname}
                                disabled={loading}
                            />
                        </Col>
                    </Row>
                    <Row>
                        <Col span={24}><Text>管理员</Text><Text type='danger'>*</Text></Col>
                        <Col span={24}>
                            <Select
                                allowClear
                                showSearch
                                placeholder='请选择'
                                style={{ width: '100%' }}
                                value={adminUserULID || undefined}
                                onChange={(value) => setAdminUserULID(value ?? '')}
                                disabled={loading}
                                filterOption={(input, option) =>
                                    option?.label?.toLowerCase().includes(input.toLowerCase())
                                }
                                options={(usersLists || []).map(item => ({
                                    value: item.key,
                                    label: item.username,
                                    key: item.key,
                                }))}
                                notFoundContent='暂无数据'
                            />
                        </Col>
                    </Row>
                    <Row>
                        <Col span={24}><Text>角色</Text><Text type='danger'>*</Text></Col>
                        <Col span={24}>
                            <Select
                                allowClear
                                showSearch
                                value={roleULID || undefined}
                                placeholder='请选择'
                                style={{ width: '100%' }}
                                onChange={(value) => setRoleULID(value || '')}
                                disabled={loading}
                                filterOption={(input, option) =>
                                    option?.label?.toLowerCase().includes(input.toLowerCase())
                                }
                                options={(rolesLists || []).map(item => ({
                                    value: item.key,
                                    label: item.rolename,
                                    key: item.key,
                                }))}
                                notFoundContent='暂无数据'
                            />
                        </Col>
                    </Row>
                    <Row>
                        <Col span={24}>描述</Col>
                        <Col span={24}>
                            <TextArea
                                placeholder='请输入'
                                autosize={{ minRows: 3, maxRows: 3 }}
                                onChange={(e) => setDescription(e.target.value)}
                                disabled={loading}
                                value={description}
                            />
                        </Col>
                    </Row>
                </Flex>
            </Modal>
        </>
    );
}

export default Entity;